import React, { useEffect, useState } from "react";
import Breadcrumb2 from "../../../Components/Breadcrumb2/Breadcrumb2";
import CustomerCare from "../../../Components/CustomerCare/CustomerCare";
import OurStores from "../../../Components/OurStories/OurStores";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const LuapulaProvinceCourtesyCall = () => {
    const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Image_1.png";
    const ArrowLeft = "https://izbassetsmain.blob.core.windows.net/izbwebassets/LeftArrow.png";
    const ArrowRight = "https://izbassetsmain.blob.core.windows.net/izbwebassets/RightArrow.png";

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowLeft}
                className={className}
                style={{
                    ...style,
                    display: "block",
                    width: "50px",
                    height: "50px",
                    left: "-58px",
                    zIndex: "99"
                }}
                onClick={onClick}
            />
        );
    }

    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <img
                src={ArrowRight}
                className={className}
                onClick={onClick}
            />
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <Breadcrumb2
                Heading="Latest News"
                img={BackgroundBrundcrumb}
                show={true}
            />

            <section>
                <div className="container pt-5">
                    <h1 className="pb-5 text-left">Indo Zambia Bank Pays Courtesy Call on Luapula Province Minister</h1>

                    <p className="pb-3">Today, we paid a courtesy call on the Office of the Luapula Province Minister, Hon. Eng. Nason Musonda MP, where we engaged in productive and forward looking discussions on how we can support key developmental projects across the province.</p>

                    <p className="pb-3">Our team, led by Unit Head – Retail, SME & Agriculture, Mr. Joseph Nyendwa, reaffirmed the Bank's commitment to driving economic growth through tailored financial solutions aligned with Luapula Province's priority sectors. These include initiatives such as the Indo Fish Farming Scheme, Indo Tourism Booster, Indo Agro Finance, Indo Ka Sumfin Loan, Indo Women Power Loan, as well as continued support to Local Authorities.</p>

                    <p className="pb-3">The team also paid a courtesy call on the Permanent Secretary for Luapula Province, Mrs. Prudence Chinama Kangwa, who expressed sincere appreciation for the Bank's support as a sponsor of the Luapula Investment Expo 2026, scheduled to run from 20th to 24th April 2026 in Mansa.</p>

                    <p className="pb-3">Through engagements such as these, the Bank continues to live its brand promise of "Supporting You, Developing Zambia," working hand in hand with Government and communities to drive meaningful and sustainable economic growth across the nation.</p>

                    <p className="pb-3"><b><em>#IndoZambiaBank #LuapulaProvince #EconomicGrowth #SupportingYouDevelopingZambia</em></b></p>

                    <h2 className="pt-5 pb-4 text-left">Gallery</h2>
                    <Slider {...settings}>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0676.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0698.JPG" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0697.JPG" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0696.JPG" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0695.JPG" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0645.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0663.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0658.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0661.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                        <div className="px-2">
                            <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/DSC_0662.jpg" style={{ width: "100%", height: "auto" }} alt="Gallery" />
                        </div>
                    </Slider>
                </div>
            </section>

            <CustomerCare />
            <OurStores />
        </>
    );
};

export default LuapulaProvinceCourtesyCall;
